//If you want to import everything from bootstrap uncomment this line and comment everything else below
//import 'bootstrap';

// Import just what we need
import { Collapse, Dropdown, Tab, Modal } from 'bootstrap';

window.bs = {};

window.bs.Collapse = Collapse;
window.bs.Dropdown = Dropdown;
window.bs.Tab = Tab;
window.bs.Modal = Modal;
